<template>
  <div class="page">
    <header class="page-header">
      <h2 class="page-title">门店管理</h2>
      <p class="page-desc">维护理疗门店资料及小程序预约成功页展示的客服信息。</p>
    </header>

    <div class="info-banner card">
      <span class="info-banner-icon" aria-hidden="true">i</span>
      <div class="info-banner-body">
        <strong>小程序如何使用这些数据</strong>
        <p>
          <strong>联系电话</strong>用于「一键拨号」；<strong>客服微信号</strong>供用户复制添加；<strong>客服二维码</strong>在预约成功页展示，建议上传清晰方形图。
        </p>
      </div>
    </div>

    <section class="card form-card">
      <div class="section-head">
        <span class="section-badge">1</span>
        <div>
          <h3 class="section-title">门店基础信息</h3>
          <p class="section-sub">名称、联系方式与地址</p>
        </div>
      </div>
      <div class="form-card-body">
        <div class="form-grid form-grid-3">
          <div class="form-field">
            <label>门店名称</label>
            <input
              v-model="form.name"
              class="control control-block"
              type="text"
              placeholder="如：智享理疗（朝阳店）"
            />
          </div>
          <div class="form-field">
            <label>联系电话（客服电话）</label>
            <input
              v-model="form.phone"
              class="control control-block"
              type="text"
              placeholder="用户拨号将使用此号码"
            />
          </div>
          <div class="form-field">
            <label>营业时间</label>
            <input
              v-model="form.businessHours"
              class="control control-block"
              type="text"
              placeholder="如：09:00–21:00"
            />
          </div>
        </div>
        <div class="form-field">
          <label>门店地址</label>
          <textarea
            v-model="form.address"
            class="control control-textarea"
            rows="3"
            placeholder="完整地址，便于用户查找"
          />
        </div>
      </div>
    </section>

    <section class="card form-card">
      <div class="section-head">
        <span class="section-badge">2</span>
        <div>
          <h3 class="section-title">客服与小程序展示</h3>
          <p class="section-sub">预约成功页与门店信息页会读取以下配置</p>
        </div>
      </div>
      <div class="form-card-body">
        <div class="form-grid form-grid-split">
          <div class="form-field">
            <label>客服微信号</label>
            <input
              v-model="form.customerServiceWechat"
              class="control control-block"
              type="text"
              placeholder="用户点击「复制客服微信」时复制的内容"
            />
          </div>
          <div class="form-field qr-field">
            <label>客服微信二维码</label>
            <div class="qr-panel">
              <input
                ref="qrInput"
                type="file"
                accept="image/*"
                class="sr-only"
                @change="uploadQr"
              />
              <div class="image-preview-container">
                <img
                  v-if="form.customerServiceQrImageUrl"
                  :src="getPreviewUrl(form.customerServiceQrImageUrl)"
                  alt="客服二维码预览"
                  class="image-preview"
                />
                <div v-else class="image-placeholder">上传后在此预览</div>
              </div>
              <div class="image-upload-actions">
                <button type="button" class="btn btn-ghost btn-sm" @click="$refs.qrInput.click()">
                  {{ form.customerServiceQrImageUrl ? '更换图片' : '上传图片' }}
                </button>
                <button
                  v-if="form.customerServiceQrImageUrl"
                  type="button"
                  class="btn btn-text-danger btn-sm"
                  @click.prevent="form.customerServiceQrImageUrl = ''"
                >
                  清除
                </button>
                <span v-if="uploadingQr" class="upload-status">上传中…</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="card form-card">
      <div class="section-head">
        <span class="section-badge">3</span>
        <div>
          <h3 class="section-title">小程序 / H5 渠道</h3>
          <p class="section-sub">慧心家园小程序「理疗预约」入口与独立康养 H5 站点地址</p>
        </div>
      </div>
      <div class="form-card-body">
        <div class="form-field">
          <label>H5 站点 URL</label>
          <input
            v-model="form.h5SiteUrl"
            class="control control-block"
            type="url"
            placeholder="https://kangyang.yourdomain.com"
          />
          <p class="field-hint">用户手机浏览器或公众号菜单打开的康养站点根地址。</p>
        </div>
        <div class="form-field">
          <label>服务号关注 / 菜单链接</label>
          <input
            v-model="form.officialAccountFollowUrl"
            class="control control-block"
            type="url"
            placeholder="服务号自定义菜单或图文链接（小程序入口用）"
          />
          <p class="field-hint">小程序首页「理疗预约」卡片将引导用户前往此地址；H5 关注引导以推广二维码为准。</p>
        </div>
        <div class="form-field qr-field">
          <label>服务号推广二维码</label>
          <div class="qr-panel">
            <input
              ref="oaQrInput"
              type="file"
              accept="image/*"
              class="sr-only"
              @change="uploadOaQr"
            />
            <div class="image-preview-container">
              <img
                v-if="form.officialAccountQrImageUrl"
                :src="getPreviewUrl(form.officialAccountQrImageUrl)"
                alt="服务号推广二维码预览"
                class="image-preview"
              />
              <div v-else class="image-placeholder">上传慧兰Bodhi 等服务号推广二维码</div>
            </div>
            <div class="image-upload-actions">
              <button type="button" class="btn btn-ghost btn-sm" @click="$refs.oaQrInput.click()">
                {{ form.officialAccountQrImageUrl ? '更换图片' : '上传图片' }}
              </button>
              <button
                v-if="form.officialAccountQrImageUrl"
                type="button"
                class="btn btn-text-danger btn-sm"
                @click.prevent="form.officialAccountQrImageUrl = ''"
              >
                清除
              </button>
              <span v-if="uploadingOaQr" class="upload-status">上传中…</span>
            </div>
            <p class="field-hint">康养 H5「关注服务号后继续」页将展示此二维码，用户长按识别关注。</p>
          </div>
        </div>
        <div class="form-grid form-grid-split">
          <div class="form-field">
            <label>小程序入口展示方式</label>
            <select v-model="form.miniprogramEntryMode" class="control control-block">
              <option value="COPY_LINK">复制链接（默认）</option>
              <option value="WEBVIEW">小程序内 web-view 打开 H5</option>
              <option value="OPEN_URL">提示用户在浏览器打开</option>
            </select>
          </div>
          <div class="form-field">
            <label>入口说明文案（可选）</label>
            <input
              v-model="form.miniprogramEntryHint"
              class="control control-block"
              type="text"
              placeholder="如：请关注慧兰康养服务号完成预约"
            />
          </div>
        </div>
        <div class="channel-preview-actions">
          <button
            v-if="form.h5SiteUrl"
            type="button"
            class="btn btn-ghost btn-sm"
            @click="openPreview(form.h5SiteUrl)"
          >
            预览 H5 站点
          </button>
          <button
            v-if="form.officialAccountFollowUrl"
            type="button"
            class="btn btn-ghost btn-sm"
            @click="openPreview(form.officialAccountFollowUrl)"
          >
            预览服务号链接
          </button>
        </div>
      </div>
    </section>

    <section class="card form-card">
      <div class="section-head section-head-actions">
        <div class="section-head-main">
          <span class="section-badge">4</span>
          <div>
            <h3 class="section-title">房间管理</h3>
            <p class="section-sub">维护每个房间可承接的理疗项目与容量，用于审批自动分房</p>
          </div>
        </div>
        <button type="button" class="btn btn-primary btn-sm" @click="openCreateRoomDialog">
          新增房间
        </button>
      </div>
      <div class="form-card-body">
        <div v-if="roomsError" class="alert alert-error">
          {{ roomsError }}
        </div>
        <div v-if="roomsLoading" class="room-empty">
          正在加载房间配置…
        </div>
        <div v-else-if="rooms.length === 0" class="room-empty">
          暂无房间配置。请新增房间并配置项目容量，批量审批时才能自动分配房间。
        </div>
        <div v-else class="room-list">
          <div v-for="room in rooms" :key="room.id" class="room-row">
            <div class="room-main">
              <div class="room-title-line">
                <strong class="room-name">{{ room.name }}</strong>
                <span :class="['status-pill', room.status === 'ACTIVE' ? 'status-active' : 'status-inactive']">
                  {{ room.status === 'ACTIVE' ? '启用' : '停用' }}
                </span>
                <span class="room-sort">排序 {{ room.sortOrder ?? 0 }}</span>
              </div>
              <div class="capacity-chips">
                <span
                  v-for="capacity in room.capacities || []"
                  :key="`${room.id}-${capacity.activityId}`"
                  class="capacity-chip"
                >
                  {{ capacity.activityName || getActivityName(capacity.activityId) || '未知项目' }} / {{ capacity.capacity }}人
                </span>
                <span v-if="!room.capacities || room.capacities.length === 0" class="capacity-empty">
                  未配置项目容量
                </span>
              </div>
            </div>
            <div class="room-actions">
              <button type="button" class="btn btn-ghost btn-sm" @click="openEditRoomDialog(room)">
                编辑
              </button>
              <button type="button" class="btn btn-ghost btn-sm" @click="toggleRoomStatus(room)">
                {{ room.status === 'ACTIVE' ? '停用' : '启用' }}
              </button>
              <button type="button" class="btn btn-text-danger btn-sm" @click="deleteRoom(room)">
                删除
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <footer class="actions-bar card">
      <div class="actions-bar-inner">
        <p class="actions-hint">修改后请点击保存，小程序端将读取最新门店数据。</p>
        <button type="button" class="btn btn-primary btn-lg" :disabled="loading" @click="save">
          {{ loading ? '保存中…' : '保存更改' }}
        </button>
      </div>
    </footer>

    <div v-if="roomDialogVisible" class="modal-backdrop">
      <div class="modal-card" role="dialog" aria-modal="true" aria-labelledby="room-dialog-title">
        <div class="modal-head">
          <div>
            <h3 id="room-dialog-title" class="modal-title">
              {{ editingRoomId ? '编辑房间' : '新增房间' }}
            </h3>
            <p class="modal-sub">每个房间至少配置一个可承接项目及容量。</p>
          </div>
          <button type="button" class="modal-close" aria-label="关闭" @click="closeRoomDialog">×</button>
        </div>
        <div class="modal-body">
          <div class="form-grid form-grid-3">
            <div class="form-field">
              <label>房间名称</label>
              <input
                v-model.trim="roomForm.name"
                class="control control-block"
                type="text"
                placeholder="如：201 房间"
              />
            </div>
            <div class="form-field">
              <label>排序</label>
              <input
                v-model.number="roomForm.sortOrder"
                class="control control-block"
                type="number"
                min="0"
              />
            </div>
            <div class="form-field">
              <label>状态</label>
              <select v-model="roomForm.status" class="control control-block">
                <option value="ACTIVE">启用</option>
                <option value="INACTIVE">停用</option>
              </select>
            </div>
          </div>

          <div class="capacity-editor">
            <div class="capacity-editor-head">
              <div>
                <h4>项目容量</h4>
                <p>同一项目不可重复，容量需大于 0。</p>
              </div>
              <button type="button" class="btn btn-ghost btn-sm" @click="addCapacityRow">
                添加项目
              </button>
            </div>
            <div v-if="activityOptions.length === 0" class="alert alert-warning">
              暂无已发布理疗项目，请先发布项目后再配置房间容量。
            </div>
            <div
              v-for="(capacity, index) in roomForm.capacities"
              :key="index"
              class="capacity-row"
            >
              <select v-model="capacity.activityId" class="control control-block">
                <option :value="null">请选择项目</option>
                <option v-for="activity in activityOptions" :key="activity.id" :value="activity.id">
                  {{ activity.name }}
                </option>
              </select>
              <input
                v-model.number="capacity.capacity"
                class="control capacity-input"
                type="number"
                min="1"
                placeholder="容量"
              />
              <button
                type="button"
                class="btn btn-text-danger btn-sm"
                @click="removeCapacityRow(index)"
              >
                移除
              </button>
            </div>
          </div>
        </div>
        <div class="modal-actions">
          <button type="button" class="btn btn-ghost" @click="closeRoomDialog">取消</button>
          <button type="button" class="btn btn-primary" :disabled="roomSaving" @click="saveRoom">
            {{ roomSaving ? '保存中…' : '保存房间' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { therapyStoreService } from '@/services/therapyStoreService'
import { therapyRoomService } from '@/services/therapyRoomService'
import { therapyActivityService } from '@/services/therapyActivityService'
import { normalizeOssUrlForPresign } from '@/utils/ossUrl'

const createEmptyRoomForm = () => ({
  name: '',
  status: 'ACTIVE',
  sortOrder: 0,
  capacities: []
})

export default {
  name: 'TherapyStoreManagement',
  data() {
    return {
      form: {
        name: '',
        phone: '',
        businessHours: '',
        address: '',
        customerServiceWechat: '',
        customerServiceQrImageUrl: '',
        h5SiteUrl: '',
        officialAccountFollowUrl: '',
        officialAccountQrImageUrl: '',
        miniprogramEntryMode: 'COPY_LINK',
        miniprogramEntryHint: ''
      },
      loading: false,
      uploadingQr: false,
      uploadingOaQr: false,
      previewUrls: {},
      rooms: [],
      roomDialogVisible: false,
      editingRoomId: null,
      roomForm: createEmptyRoomForm(),
      activityOptions: [],
      roomsLoading: false,
      roomsError: '',
      roomSaving: false
    }
  },
  async mounted() {
    await Promise.all([
      this.loadStore(),
      this.loadRooms(),
      this.loadActivityOptions()
    ])
  },
  methods: {
    async loadStore() {
      this.loading = true
      try {
        const res = await therapyStoreService.getStore()
        if (res.data) {
          const data = { ...res.data }
          if (data.imageUrl) data.imageUrl = normalizeOssUrlForPresign(data.imageUrl)
          if (data.customerServiceQrImageUrl) {
            data.customerServiceQrImageUrl = normalizeOssUrlForPresign(data.customerServiceQrImageUrl)
          }
          if (data.officialAccountQrImageUrl) {
            data.officialAccountQrImageUrl = normalizeOssUrlForPresign(data.officialAccountQrImageUrl)
          }
          this.form = { ...this.form, ...data }
        }
      } catch (e) {
        alert(e?.response?.data?.error || '加载门店信息失败')
      } finally {
        this.loading = false
      }
    },
    async loadRooms() {
      this.roomsLoading = true
      this.roomsError = ''
      try {
        const res = await therapyRoomService.list()
        this.rooms = res.data || []
      } catch (e) {
        this.roomsError = e?.response?.data?.error || e?.response?.data?.message || '加载房间配置失败'
      } finally {
        this.roomsLoading = false
      }
    },
    async loadActivityOptions() {
      try {
        const res = await therapyActivityService.fetchList({ status: 'PUBLISHED', page: 0, size: 1000 })
        this.activityOptions = res.data?.content || []
      } catch (e) {
        console.error('加载理疗项目失败', e)
      }
    },
    async save() {
      this.loading = true
      try {
        await therapyStoreService.updateStore(this.form)
        alert('保存成功')
      } catch (e) {
        alert(e?.response?.data?.error || '保存失败')
      } finally {
        this.loading = false
      }
    },
    async uploadQr(event) {
      const file = event.target.files[0]
      if (!file) return
      this.uploadingQr = true
      try {
        const res = await therapyStoreService.uploadQrImage(file)
        if (res.success && res.data?.url) {
          this.form.customerServiceQrImageUrl = res.data.url
        }
      } catch (e) {
        alert(e?.response?.data?.message || '上传失败')
      } finally {
        this.uploadingQr = false
        event.target.value = ''
      }
    },
    async uploadOaQr(event) {
      const file = event.target.files[0]
      if (!file) return
      this.uploadingOaQr = true
      try {
        const res = await therapyStoreService.uploadQrImage(file)
        if (res.success && res.data?.url) {
          this.form.officialAccountQrImageUrl = res.data.url
        }
      } catch (e) {
        alert(e?.response?.data?.message || '上传失败')
      } finally {
        this.uploadingOaQr = false
        event.target.value = ''
      }
    },
    openPreview(url) {
      if (!url) return
      window.open(url, '_blank', 'noopener,noreferrer')
    },
    getActivityName(activityId) {
      const activity = this.activityOptions.find(item => String(item.id) === String(activityId))
      return activity?.name || ''
    },
    openCreateRoomDialog() {
      this.editingRoomId = null
      this.roomForm = createEmptyRoomForm()
      this.addCapacityRow()
      this.roomDialogVisible = true
    },
    openEditRoomDialog(room) {
      this.editingRoomId = room.id
      this.roomForm = {
        name: room.name || '',
        status: room.status || 'ACTIVE',
        sortOrder: room.sortOrder ?? 0,
        capacities: (room.capacities || []).map(item => ({
          activityId: item.activityId,
          capacity: item.capacity
        }))
      }
      this.roomDialogVisible = true
    },
    closeRoomDialog() {
      if (this.roomSaving) return
      this.roomDialogVisible = false
      this.editingRoomId = null
      this.roomForm = createEmptyRoomForm()
    },
    addCapacityRow() {
      this.roomForm.capacities.push({ activityId: null, capacity: 1 })
    },
    removeCapacityRow(index) {
      this.roomForm.capacities.splice(index, 1)
    },
    validateRoomForm() {
      if (!this.roomForm.name?.trim()) {
        alert('请填写房间名称')
        return false
      }
      if (!this.roomForm.capacities.length) {
        alert('请至少添加一条项目容量')
        return false
      }
      const activityIds = new Set()
      for (const item of this.roomForm.capacities) {
        if (!item.activityId) {
          alert('请选择容量对应的理疗项目')
          return false
        }
        if (!Number.isFinite(Number(item.capacity)) || Number(item.capacity) <= 0) {
          alert('项目容量必须大于 0')
          return false
        }
        const key = String(item.activityId)
        if (activityIds.has(key)) {
          alert('同一项目不能重复配置')
          return false
        }
        activityIds.add(key)
      }
      return true
    },
    buildRoomPayload() {
      return {
        name: this.roomForm.name.trim(),
        status: this.roomForm.status,
        sortOrder: Number(this.roomForm.sortOrder) || 0,
        capacities: this.roomForm.capacities.map(item => ({
          activityId: item.activityId,
          capacity: Number(item.capacity)
        }))
      }
    },
    async saveRoom() {
      if (!this.validateRoomForm()) return
      this.roomSaving = true
      try {
        const payload = this.buildRoomPayload()
        if (this.editingRoomId) {
          await therapyRoomService.update(this.editingRoomId, payload)
        } else {
          await therapyRoomService.create(payload)
        }
        await this.loadRooms()
        this.roomDialogVisible = false
        this.editingRoomId = null
        this.roomForm = createEmptyRoomForm()
      } catch (e) {
        alert(e?.response?.data?.error || e?.response?.data?.message || '保存房间失败')
      } finally {
        this.roomSaving = false
      }
    },
    async toggleRoomStatus(room) {
      const nextStatus = room.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE'
      const message = nextStatus === 'INACTIVE'
        ? '停用后不会参与自动分房，历史预约不受影响。确定停用该房间吗？'
        : '确定启用该房间吗？'
      if (!window.confirm(message)) return
      try {
        await therapyRoomService.updateStatus(room.id, nextStatus)
        await this.loadRooms()
      } catch (e) {
        alert(e?.response?.data?.error || e?.response?.data?.message || '更新房间状态失败')
      }
    },
    async deleteRoom(room) {
      if (!window.confirm('确定删除该房间吗？若已被历史预约引用，后端可能会改为停用。')) return
      try {
        await therapyRoomService.remove(room.id)
        await this.loadRooms()
      } catch (e) {
        alert(e?.response?.data?.error || e?.response?.data?.message || '删除房间失败')
      }
    },
    getPreviewUrl(url) {
      if (!url) return ''
      if (url.startsWith('data:')) return url
      const cacheKey = normalizeOssUrlForPresign(url)
      if (this.previewUrls[cacheKey]) return this.previewUrls[cacheKey]
      if (url.includes('aliyuncs.com')) {
        therapyStoreService.getPresignedUrl(url).then((res) => {
          const u = res.data?.url || res.url
          if (u) this.previewUrls = { ...this.previewUrls, [cacheKey]: u }
        }).catch(() => {
          this.previewUrls = { ...this.previewUrls, [cacheKey]: url }
        })
        return ''
      }
      if (url.startsWith('http')) return url
      return ''
    }
  }
}
</script>

<style scoped>
.page {
  --control-h: 40px;
  --radius: 8px;
  --border: 1px solid #d1d9e0;
  --bg-card: #fff;
  --text: #1f2937;
  --text-muted: #6b7280;
  --primary: #0d9488;
  --primary-hover: #0f766e;
  --shadow-sm: 0 1px 2px rgba(15, 23, 42, 0.06);
  padding: 1.25rem 1.5rem 2.5rem;
  max-width: 960px;
  margin: 0 auto;
  box-sizing: border-box;
  color: var(--text);
}

.page-header {
  margin-bottom: 1.25rem;
}

.page-title {
  margin: 0 0 0.35rem;
  font-size: 1.35rem;
  font-weight: 600;
  letter-spacing: -0.02em;
}

.page-desc {
  margin: 0;
  font-size: 0.95rem;
  color: var(--text-muted);
  line-height: 1.5;
}

.card {
  background: var(--bg-card);
  border-radius: var(--radius);
  border: var(--border);
  box-shadow: var(--shadow-sm);
}

.info-banner {
  display: flex;
  gap: 14px;
  align-items: flex-start;
  padding: 14px 18px;
  margin-bottom: 1.25rem;
  background: linear-gradient(135deg, #f0fdfa 0%, #ecfeff 100%);
  border-color: #99f6e4;
}

.info-banner-icon {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--primary);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  font-style: italic;
  line-height: 28px;
  text-align: center;
}

.info-banner-body strong {
  display: block;
  font-size: 14px;
  margin-bottom: 6px;
  color: #134e4a;
}

.info-banner-body p {
  margin: 0;
  font-size: 13px;
  line-height: 1.55;
  color: #115e59;
}

.field-hint {
  margin: 6px 0 0;
  font-size: 12px;
  color: var(--text-muted);
  line-height: 1.45;
}

.channel-preview-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 8px;
}

.form-card {
  margin-bottom: 1.25rem;
  overflow: hidden;
}

.section-head {
  display: flex;
  gap: 14px;
  align-items: flex-start;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #eef2f7;
  background: #fafafa;
}

.section-badge {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: linear-gradient(145deg, #14b8a6, #0d9488);
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  line-height: 32px;
  text-align: center;
}

.section-title {
  margin: 0 0 4px;
  font-size: 1.05rem;
  font-weight: 600;
}

.section-sub {
  margin: 0;
  font-size: 13px;
  color: var(--text-muted);
}

.form-card-body {
  padding: 1.25rem;
}

.form-grid {
  display: grid;
  gap: 1rem 1.25rem;
}

.form-grid-3 {
  grid-template-columns: repeat(3, 1fr);
}

.form-grid-split {
  grid-template-columns: 1fr 280px;
  align-items: start;
}

@media (max-width: 900px) {
  .form-grid-3 {
    grid-template-columns: 1fr;
  }
  .form-grid-split {
    grid-template-columns: 1fr;
  }
}

.form-field {
  margin-bottom: 0;
}

.form-field label {
  display: block;
  margin-bottom: 6px;
  font-size: 13px;
  font-weight: 500;
  color: var(--text-muted);
}

.control {
  height: var(--control-h);
  min-height: var(--control-h);
  line-height: calc(var(--control-h) - 2px);
  padding: 0 12px;
  box-sizing: border-box;
  width: 100%;
  max-width: 220px;
  font-size: 14px;
  color: var(--text);
  background: #fff;
  border: var(--border);
  border-radius: var(--radius);
  transition: border-color 0.15s, box-shadow 0.15s;
}

.control-block {
  max-width: none;
}

.control::placeholder {
  color: #9ca3af;
}

.control:hover:not(:disabled) {
  border-color: #b8c0cc;
}

.control:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(13, 148, 136, 0.18);
}

.control-textarea {
  height: auto;
  min-height: 88px;
  line-height: 1.5;
  padding: 10px 12px;
  resize: vertical;
  max-width: none;
}

.qr-panel {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.image-preview-container {
  width: 100%;
  max-width: 240px;
  min-height: 140px;
  border: 2px dashed #d1d5db;
  border-radius: var(--radius);
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f9fafb;
  overflow: hidden;
}

.image-preview {
  max-width: 100%;
  max-height: 240px;
  width: auto;
  height: auto;
  object-fit: contain;
  display: block;
}

.image-placeholder {
  color: #9ca3af;
  font-size: 13px;
  padding: 1.5rem;
  text-align: center;
}

.image-upload-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
}

.upload-status {
  color: var(--primary);
  font-size: 13px;
  font-weight: 500;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.btn {
  height: var(--control-h);
  min-height: var(--control-h);
  padding: 0 16px;
  box-sizing: border-box;
  font-size: 14px;
  font-weight: 500;
  border-radius: var(--radius);
  border: var(--border);
  cursor: pointer;
  background: #fff;
  color: var(--text);
  transition: background 0.15s, border-color 0.15s, color 0.15s;
}

.btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.btn-primary {
  background: var(--primary);
  border-color: var(--primary);
  color: #fff;
}

.btn-primary:hover:not(:disabled) {
  background: var(--primary-hover);
  border-color: var(--primary-hover);
}

.btn-ghost {
  background: #fff;
  border-color: #d1d9e0;
}

.btn-ghost:hover:not(:disabled) {
  background: #f9fafb;
}

.btn-sm {
  height: 32px;
  min-height: 32px;
  padding: 0 12px;
  font-size: 13px;
}

.btn-lg {
  height: 44px;
  min-height: 44px;
  padding: 0 22px;
  font-size: 15px;
  font-weight: 600;
}

.btn-text-danger {
  background: transparent;
  border: none;
  color: #dc2626;
  padding-left: 8px;
  padding-right: 8px;
}

.btn-text-danger:hover:not(:disabled) {
  text-decoration: underline;
  background: transparent;
}

.section-head-actions {
  align-items: center;
  justify-content: space-between;
}

.section-head-main {
  display: flex;
  gap: 14px;
  align-items: flex-start;
}

.alert {
  padding: 10px 12px;
  margin-bottom: 12px;
  border-radius: var(--radius);
  font-size: 13px;
  line-height: 1.5;
}

.alert-error {
  color: #991b1b;
  background: #fef2f2;
  border: 1px solid #fecaca;
}

.alert-warning {
  color: #92400e;
  background: #fffbeb;
  border: 1px solid #fde68a;
}

.room-empty {
  padding: 22px;
  color: var(--text-muted);
  font-size: 14px;
  text-align: center;
  background: #f9fafb;
  border: 1px dashed #d1d5db;
  border-radius: var(--radius);
}

.room-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.room-row {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  justify-content: space-between;
  padding: 14px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: var(--radius);
}

.room-main {
  min-width: 0;
  flex: 1;
}

.room-title-line {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  margin-bottom: 10px;
}

.room-name {
  font-size: 15px;
  color: var(--text);
}

.room-sort {
  color: var(--text-muted);
  font-size: 12px;
}

.status-pill {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 8px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
}

.status-active {
  color: #047857;
  background: #d1fae5;
}

.status-inactive {
  color: #6b7280;
  background: #e5e7eb;
}

.capacity-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.capacity-chip {
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  padding: 0 10px;
  color: #0f766e;
  background: #ecfdf5;
  border: 1px solid #a7f3d0;
  border-radius: 999px;
  font-size: 12px;
}

.capacity-empty {
  color: var(--text-muted);
  font-size: 13px;
}

.room-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
}

.modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(15, 23, 42, 0.42);
}

.modal-card {
  width: min(760px, 100%);
  max-height: min(86vh, 720px);
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 22px 60px rgba(15, 23, 42, 0.22);
  overflow: hidden;
}

.modal-head {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  justify-content: space-between;
  padding: 18px 20px;
  border-bottom: 1px solid #eef2f7;
  background: #fafafa;
}

.modal-title {
  margin: 0 0 4px;
  font-size: 18px;
  font-weight: 600;
}

.modal-sub {
  margin: 0;
  color: var(--text-muted);
  font-size: 13px;
}

.modal-close {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  color: var(--text-muted);
  background: transparent;
  cursor: pointer;
  font-size: 24px;
  line-height: 28px;
}

.modal-close:hover {
  background: #eef2f7;
}

.modal-body {
  padding: 20px;
  overflow-y: auto;
}

.modal-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  padding: 14px 20px;
  border-top: 1px solid #eef2f7;
}

.capacity-editor {
  margin-top: 20px;
  padding: 14px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: var(--radius);
}

.capacity-editor-head {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 12px;
}

.capacity-editor-head h4 {
  margin: 0 0 4px;
  font-size: 14px;
  font-weight: 600;
}

.capacity-editor-head p {
  margin: 0;
  color: var(--text-muted);
  font-size: 12px;
}

.capacity-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 120px auto;
  gap: 10px;
  align-items: center;
  margin-top: 10px;
}

.capacity-input {
  max-width: none;
}

@media (max-width: 700px) {
  .section-head-actions,
  .room-row,
  .capacity-editor-head {
    align-items: stretch;
    flex-direction: column;
  }

  .room-actions {
    justify-content: flex-start;
  }

  .capacity-row {
    grid-template-columns: 1fr;
  }
}

.actions-bar {
  position: sticky;
  bottom: 1rem;
  margin-top: 0.5rem;
}

.actions-bar-inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 1.25rem;
}

.actions-hint {
  margin: 0;
  font-size: 13px;
  color: var(--text-muted);
  flex: 1;
  min-width: 200px;
}
</style>
